

// *************** code 3 : regrouppement des sous sujets ***************
// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { Editor } from "@tinymce/tinymce-react";
// import axios from "axios";
// import { Checkbox, Select, Input, Form, Button } from "antd";
// import courseService from "../../services/course.service";

// const GOOGLE_API_KEY = "AIzaSyA6EgdqzOLETjRljfNwHvRtwXRzhkZAnEk"; // Remplacez par votre clé API valide
// const { Option } = Select;

// const AddSubjectForm = ({ courseId: propCourseId, subject: existingSubject, onClose }) => {
//     const params = useParams();
//     const navigate = useNavigate();
//     const courseId = propCourseId || params.courseId || existingSubject?.courseId;
//     const [isNewSubTitle, setIsNewSubTitle] = useState(false); // Gère la case à cocher "Nouveau sous-sujet ?"
//     const [subTitleOptions, setSubTitleOptions] = useState([]); // Stocke les sous-sujets disponibles
//     useEffect(() => {
//         const fetchSubTitles = async () => {
//             try {
//                 const subjectsData = await courseService.getSubjectsByCourse(courseId);
//                 const uniqueSubTitles = [...new Set(subjectsData.map((s) => s.subTitle).filter(Boolean))]; // Élimine les valeurs nulles
//                 setSubTitleOptions(uniqueSubTitles);
//             } catch (err) {
//                 console.error("Erreur lors de la récupération des sous-sujets :", err);
//             }
//         };

//         if (courseId) {
//             fetchSubTitles();
//         }
//     }, [courseId]);
//     const handleNewSubTitleChange = (e) => {
//         setIsNewSubTitle(e.target.checked);
//         if (!e.target.checked) {
//             setSubject((prev) => ({ ...prev, subTitle: "" })); // Réinitialise la valeur si décoché
//         }
//     };


//     // const [subject, setSubject] = useState({
//     //     group_name: existingSubject?.group_name || "",
//     //     title: existingSubject?.title || "",
//     //     content: existingSubject?.content || "",
//     // });

//     // const [subject, setSubject] = useState({
//     //     group_name: existingSubject?.group_name || "",
//     //     title: existingSubject?.title || "",
//     //     subTitle: existingSubject?.subTitle || "", // Nouveau champ
//     //     content: existingSubject?.content || "",
//     // });

//     const [subject, setSubject] = useState({
//         group_name: existingSubject?.group_name || "",
//         title: existingSubject?.title || "",
//         subTitle: existingSubject?.subTitle || "", // Ajout du sous-titre
//         content: existingSubject?.content || "",
//     });



//     const [groups, setGroups] = useState([]);
//     const [isNewGroup, setIsNewGroup] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [success, setSuccess] = useState(false);
//     const editorRef = useRef(null);

//     useEffect(() => {
//         if (existingSubject) {
//             setSubject({
//                 group_name: existingSubject.group_name || "",
//                 title: existingSubject.title || "",
//                 subTitle: existingSubject.subTitle || "", // Vérifiez que ce champ est bien récupéré
//                 content: existingSubject.content || "",
//             });
//         }
//     }, [existingSubject]);


//     // Récupération des groupes existants
//     useEffect(() => {
//         const fetchGroups = async () => {
//             try {
//                 const subjectsData = await courseService.getSubjectsByCourse(courseId);
//                 const uniqueGroups = [...new Set(subjectsData.map((s) => s.group_name))];
//                 setGroups(uniqueGroups);
//             } catch (err) {
//                 console.error("Erreur lors de la récupération des groupes :", err);
//             }
//         };

//         if (courseId) {
//             fetchGroups();
//         }
//     }, [courseId]);

//     // const handleInputChange = (e) => {
//     //     const { name, value } = e.target;
//     //     setSubject((prev) => ({ ...prev, [name]: value }));
//     // };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setSubject((prev) => ({ ...prev, [name]: value }));
//     };


//     const handleGroupChange = (value) => {
//         setSubject((prev) => ({ ...prev, group_name: value }));
//     };

//     const handleCheckboxChange = (e) => {
//         setIsNewGroup(e.target.checked);
//         if (!e.target.checked) {
//             setSubject((prev) => ({ ...prev, group_name: "" }));
//         }
//     };

//     const handleEditorChange = async (value) => {
//         const googleDriveRegex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\/view\?usp=sharing/g;
//         const match = googleDriveRegex.exec(value);

//         if (match) {
//             const fileId = match[1]; // Extraire l'ID du fichier Google Drive

//             try {
//                 const metadataUrl = `https://www.googleapis.com/drive/v3/files/${fileId}?fields=mimeType&key=${GOOGLE_API_KEY}`;
//                 const response = await axios.get(metadataUrl);
//                 const mimeType = response.data.mimeType;
//                 let embeddedContent = "";

//                 if (mimeType.startsWith("image/")) {
//                     embeddedContent = `<img src="https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}"
//                         alt="Image Google Drive" style="width: 100%; height: auto; border-radius: 10px;" />`;
//                 } else if (mimeType.startsWith("video/")) {
//                     embeddedContent = `<video controls style="width: 100%; height: auto; border-radius: 10px;">
//                         <source src="https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}" type="${mimeType}" />
//                         Votre navigateur ne supporte pas les vidéos HTML5.
//                     </video>`;
//                 } else if (mimeType === "application/pdf") {
//                     embeddedContent = `<a href="https://drive.google.com/file/d/${fileId}/view" target="_blank"
//                         rel="noopener noreferrer" style="color: blue; text-decoration: underline;">
//                         Ouvrir le document PDF
//                     </a>`;
//                 } else {
//                     embeddedContent = `<p>Type de fichier non pris en charge : ${mimeType}</p>`;
//                 }

//                 setSubject((prev) => ({ ...prev, content: prev.content + embeddedContent }));
//             } catch (error) {
//                 console.error("Erreur lors de la récupération des métadonnées du fichier :", error);
//             }
//         } else {
//             setSubject((prev) => ({ ...prev, content: value }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setError(null);

//         if (!subject.group_name || !subject.title) {
//             setError("Veuillez remplir tous les champs requis.");
//             setLoading(false);
//             return;
//         }

//         // try {
//         //     if (existingSubject?.id) {
//         //         await courseService.updateSubject(existingSubject.id, { ...subject, courseId });
//         //     } else {
//         //         await courseService.addSubjectToCourse(courseId, subject);
//         //     }

//         //     setSuccess(true);
//         //     setTimeout(() => {
//         //         if (onClose) onClose();
//         //         navigate("/mod/courses");
//         //     }, 1000);
//         // } catch (err) {
//         //     setError(err.message || "Une erreur s'est produite.");
//         // }
//         try {
//             if (existingSubject?.id) {
//                 await courseService.updateSubject(existingSubject.id, { ...subject, courseId });
//             } else {
//                 await courseService.addSubjectToCourse(courseId, subject);
//             }

//             setSuccess(true);
//             setTimeout(() => {
//                 if (onClose) onClose();
//                 navigate("/mod/courses");
//             }, 1000);
//         } catch (err) {
//             setError(err.message || "Une erreur s'est produite.");
//         }

//         finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <form onSubmit={handleSubmit}>
//             <h3>{existingSubject ? "Modifier le sujet" : "Ajouter un sujet"}</h3>
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">
//                 {existingSubject ? "Sujet mis à jour avec succès !" : "Sujet ajouté avec succès !"}
//             </div>}

//             {/* ✅ Sélection du groupe ou saisie d'un nouveau groupe */}
//             <div className="mb-3">
//                 <label>Nom du Groupe</label>
//                 <Checkbox checked={isNewGroup} onChange={handleCheckboxChange} style={{ marginLeft: "10px" }}>
//                     Nouveau groupe ?
//                 </Checkbox>

//                 {isNewGroup ? (
//                     <Input
//                         type="text"
//                         name="group_name"
//                         className="form-control"
//                         value={subject.group_name}
//                         onChange={handleInputChange}
//                         required
//                         style={{ marginTop: "10px" }}
//                     />
//                 ) : (
//                     <Select
//                         className="form-control"
//                         value={subject.group_name || undefined}
//                         onChange={handleGroupChange}
//                         placeholder="Sélectionnez un groupe"
//                         style={{ width: "100%", marginTop: "10px" }}
//                     >
//                         {groups.map((group) => (
//                             <Option key={group} value={group}>
//                                 {group}
//                             </Option>
//                         ))}
//                     </Select>
//                 )}
//             </div>

//             {/* ✅ Titre du sujet */}
//             <div className="mb-3">
//                 <label>Titre du Sujet</label>
//                 <Input
//                     type="text"
//                     name="title"
//                     className="form-control"
//                     value={subject.title}
//                     onChange={handleInputChange}
//                     required
//                 />
//             </div>


//             {/* ✅ Sous-titre du sujet */}
//             {/* <div className="mb-3">
//                 <label>Sous-titre du Sujet</label>
//                 <Input
//                     type="text"
//                     name="subTitle"
//                     className="form-control"
//                     value={subject.subTitle}
//                     onChange={handleInputChange}
//                 />
//             </div> */}

//             {/* ✅ Sous-titre du sujet */}
//             {/* <div className="mb-3">
//                 <label>Sous-titre du Sujet</label>
//                 <Input
//                     type="text"
//                     name="subTitle"
//                     className="form-control"
//                     value={subject.subTitle}
//                     onChange={handleInputChange}
//                 />
//             </div> */}

//             {/* ✅ Sous-titre du sujet */}
//             <div className="mb-3">
//                 <label>Sous-titre du Sujet</label>
//                 <Checkbox
//                     checked={isNewSubTitle}
//                     onChange={handleNewSubTitleChange}
//                     style={{ marginLeft: "10px" }}
//                 >
//                     Nouveau sous-sujet ?
//                 </Checkbox>

//                 {isNewSubTitle ? (
//                     <Input
//                         type="text"
//                         name="subTitle"
//                         className="form-control"
//                         value={subject.subTitle}
//                         onChange={handleInputChange}
//                         required
//                         style={{ marginTop: "10px" }}
//                     />
//                 ) : (
//                     <Select
//                         className="form-control"
//                         value={subject.subTitle || undefined}
//                         onChange={(value) => setSubject((prev) => ({ ...prev, subTitle: value }))}
//                         placeholder="Sélectionnez un sous-sujet"
//                         style={{ width: "100%", marginTop: "10px" }}
//                     >
//                         {subTitleOptions.map((subTitle) => (
//                             <Option key={subTitle} value={subTitle}>
//                                 {subTitle}
//                             </Option>
//                         ))}
//                     </Select>
//                 )}
//             </div>


//             {/* ✅ Contenu du sujet */}
//             <div className="mb-3">
//                 <label>Contenu du Sujet</label>
//                 <Editor
//                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                     value={subject.content}
//                     onInit={(evt, editor) => (editorRef.current = editor)}
//                     onEditorChange={handleEditorChange}
//                     init={{
//                         height: 500,
//                         menubar: true,
//                         plugins: [
//                             "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
//                             "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
//                             "insertdatetime", "media", "table", "help", "wordcount"
//                         ],
//                         toolbar: `undo redo | bold italic underline strikethrough | link image media |
//             alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |
//             removeformat code help`,
//                         content_style: "body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; }",
//                     }}
//                 />

//                 {/* <Editor
//                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                     value={subject.content}
//                     onInit={(evt, editor) => (editorRef.current = editor)}
//                     onEditorChange={handleEditorChange}
//                     init={{
//                         height: 500,
//                         menubar: true,
//                         plugins: [
//                             "link", "lists", "table", "paste", "code", "help"
//                         ],
//                         toolbar:
//                             "undo redo | bold italic underline | link | alignleft aligncenter alignright alignjustify | removeformat",
//                         content_style:
//                             "body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; }",
//                     }}
//                 /> */}
//             </div>

//             <Button type="primary" htmlType="submit" block loading={loading} disabled={success}>
//                 {success ? "Succès" : "Enregistrer"}
//             </Button>
//         </form>
//     );
// };

// export default AddSubjectForm;

// ********** code 4 : Regreppement des sujjets *****************
import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import { Checkbox, Select, Input, Form, Button } from "antd";
import courseService from "../../services/course.service";

const GOOGLE_API_KEY = "AIzaSyA6EgdqzOLETjRljfNwHvRtwXRzhkZAnEk"; // Remplacez par votre clé API valide
const { Option } = Select;

const AddSubjectForm = ({ courseId: propCourseId, subject: existingSubject, onClose }) => {
    const params = useParams();
    const navigate = useNavigate();
    const courseId = propCourseId || params.courseId || existingSubject?.courseId;
    const [isNewSubTitle, setIsNewSubTitle] = useState(false); // Gère la case à cocher "Nouveau sous-sujet ?"
    const [subTitleOptions, setSubTitleOptions] = useState([]); // Stocke les sous-sujets disponibles
    const [isNewTitle, setIsNewTitle] = useState(false); // ✅ Contrôle du Titre (Nouveau sujet ?)
    const [titleOptions, setTitleOptions] = useState([]); // ✅ Stocke les titres des sujets existants
    useEffect(() => {
        const fetchTitles = async () => {
            try {
                const subjectsData = await courseService.getSubjectsByCourse(courseId);
                const uniqueTitles = [...new Set(subjectsData.map((s) => s.title).filter(Boolean))];
                setTitleOptions(uniqueTitles);
            } catch (err) {
                console.error("Erreur lors de la récupération des titres :", err);
            }
        };

        if (courseId) {
            fetchTitles();
        }
    }, [courseId]);

    useEffect(() => {
        const fetchSubTitles = async () => {
            try {
                const subjectsData = await courseService.getSubjectsByCourse(courseId);
                const uniqueSubTitles = [...new Set(subjectsData.map((s) => s.subTitle).filter(Boolean))]; // Élimine les valeurs nulles
                setSubTitleOptions(uniqueSubTitles);
            } catch (err) {
                console.error("Erreur lors de la récupération des sous-sujets :", err);
            }
        };

        if (courseId) {
            fetchSubTitles();
        }
    }, [courseId]);
    const handleNewSubTitleChange = (e) => {
        setIsNewSubTitle(e.target.checked);
        if (!e.target.checked) {
            setSubject((prev) => ({ ...prev, subTitle: "" })); // Réinitialise la valeur si décoché
        }
    };


    // const [subject, setSubject] = useState({
    //     group_name: existingSubject?.group_name || "",
    //     title: existingSubject?.title || "",
    //     content: existingSubject?.content || "",
    // });

    // const [subject, setSubject] = useState({
    //     group_name: existingSubject?.group_name || "",
    //     title: existingSubject?.title || "",
    //     subTitle: existingSubject?.subTitle || "", // Nouveau champ
    //     content: existingSubject?.content || "",
    // });

    const [subject, setSubject] = useState({
        group_name: existingSubject?.group_name || "",
        title: existingSubject?.title || "",
        subTitle: existingSubject?.subTitle || "", // Ajout du sous-titre
        content: existingSubject?.content || "",
    });



    const [groups, setGroups] = useState([]);
    const [isNewGroup, setIsNewGroup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const editorRef = useRef(null);

    useEffect(() => {
        if (existingSubject) {
            setSubject({
                group_name: existingSubject.group_name || "",
                title: existingSubject.title || "",
                subTitle: existingSubject.subTitle || "", // Vérifiez que ce champ est bien récupéré
                content: existingSubject.content || "",
            });
        }
    }, [existingSubject]);


    // Récupération des groupes existants
    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const subjectsData = await courseService.getSubjectsByCourse(courseId);
                const uniqueGroups = [...new Set(subjectsData.map((s) => s.group_name))];
                setGroups(uniqueGroups);
            } catch (err) {
                console.error("Erreur lors de la récupération des groupes :", err);
            }
        };

        if (courseId) {
            fetchGroups();
        }
    }, [courseId]);

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setSubject((prev) => ({ ...prev, [name]: value }));
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSubject((prev) => ({ ...prev, [name]: value }));
    };


    const handleGroupChange = (value) => {
        setSubject((prev) => ({ ...prev, group_name: value }));
    };

    const handleCheckboxChange = (e) => {
        setIsNewGroup(e.target.checked);
        if (!e.target.checked) {
            setSubject((prev) => ({ ...prev, group_name: "" }));
        }
    };

    const handleEditorChange = async (value) => {
        const googleDriveRegex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\/view\?usp=sharing/g;
        const match = googleDriveRegex.exec(value);

        if (match) {
            const fileId = match[1]; // Extraire l'ID du fichier Google Drive

            try {
                const metadataUrl = `https://www.googleapis.com/drive/v3/files/${fileId}?fields=mimeType&key=${GOOGLE_API_KEY}`;
                const response = await axios.get(metadataUrl);
                const mimeType = response.data.mimeType;
                let embeddedContent = "";

                if (mimeType.startsWith("image/")) {
                    embeddedContent = `<img src="https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}"
                        alt="Image Google Drive" style="width: 100%; height: auto; border-radius: 10px;" />`;
                } else if (mimeType.startsWith("video/")) {
                    embeddedContent = `<video controls style="width: 100%; height: auto; border-radius: 10px;">
                        <source src="https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}" type="${mimeType}" />
                        Votre navigateur ne supporte pas les vidéos HTML5.
                    </video>`;
                } else if (mimeType === "application/pdf") {
                    embeddedContent = `<a href="https://drive.google.com/file/d/${fileId}/view" target="_blank"
                        rel="noopener noreferrer" style="color: blue; text-decoration: underline;">
                        Ouvrir le document PDF
                    </a>`;
                } else {
                    embeddedContent = `<p>Type de fichier non pris en charge : ${mimeType}</p>`;
                }

                setSubject((prev) => ({ ...prev, content: prev.content + embeddedContent }));
            } catch (error) {
                console.error("Erreur lors de la récupération des métadonnées du fichier :", error);
            }
        } else {
            setSubject((prev) => ({ ...prev, content: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (!subject.group_name || !subject.title) {
            setError("Veuillez remplir tous les champs requis.");
            setLoading(false);
            return;
        }

        // try {
        //     if (existingSubject?.id) {
        //         await courseService.updateSubject(existingSubject.id, { ...subject, courseId });
        //     } else {
        //         await courseService.addSubjectToCourse(courseId, subject);
        //     }

        //     setSuccess(true);
        //     setTimeout(() => {
        //         if (onClose) onClose();
        //         navigate("/mod/courses");
        //     }, 1000);
        // } catch (err) {
        //     setError(err.message || "Une erreur s'est produite.");
        // }
        try {
            if (existingSubject?.id) {
                await courseService.updateSubject(existingSubject.id, { ...subject, courseId });
            } else {
                await courseService.addSubjectToCourse(courseId, subject);
            }

            setSuccess(true);
            setTimeout(() => {
                if (onClose) onClose();
                navigate("/mod/courses");
            }, 1000);
        } catch (err) {
            setError(err.message || "Une erreur s'est produite.");
        }

        finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3>{existingSubject ? "Modifier le sujet" : "Ajouter un sujet"}</h3>
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">
                {existingSubject ? "Sujet mis à jour avec succès !" : "Sujet ajouté avec succès !"}
            </div>}

            {/* ✅ Sélection du groupe ou saisie d'un nouveau groupe */}
            <div className="mb-3">
                <label>Nom du Groupe</label>
                <Checkbox checked={isNewGroup} onChange={handleCheckboxChange} style={{ marginLeft: "10px" }}>
                    Nouveau groupe ?
                </Checkbox>

                {isNewGroup ? (
                    <Input
                        type="text"
                        name="group_name"
                        className="form-control"
                        value={subject.group_name}
                        onChange={handleInputChange}
                        required
                        style={{ marginTop: "10px" }}
                    />
                ) : (
                    // <Select
                    //     className="form-control"
                    //     value={subject.group_name || undefined}
                    //     onChange={handleGroupChange}
                    //     placeholder="Sélectionnez un groupe"
                    //     style={{ width: "100%", marginTop: "10px" }}
                    // >
                    //     {groups.map((group) => (
                    //         <Option key={group} value={group}>
                    //             {group}
                    //         </Option>
                    //     ))}
                    // </Select>
                    <Select
                        showSearch
                        className="form-control"
                        value={subject.group_name || undefined}
                        onChange={handleGroupChange}
                        placeholder="Sélectionnez un groupe"
                        style={{ width: "100%", marginTop: "10px" }}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {groups.map((group) => (
                            <Option key={group} value={group}>
                                {group}
                            </Option>
                        ))}
                    </Select>

                )}
            </div>

            {/* ✅ Titre du sujet */}
            {/* <div className="mb-3">
                <label>Titre du Sujet</label>
                <Input
                    type="text"
                    name="title"
                    className="form-control"
                    value={subject.title}
                    onChange={handleInputChange}
                    required
                />
            </div> */}
            {/* ✅ Titre du sujet (avec gestion de la checkbox) */}
            <div className="mb-3">
                <label>Titre du Sujet</label>
                <Checkbox checked={isNewTitle} onChange={(e) => setIsNewTitle(e.target.checked)} style={{ marginLeft: "10px" }}>
                    Nouveau sujet ?
                </Checkbox>

                {isNewTitle ? (
                    <Input
                        type="text"
                        name="title"
                        className="form-control"
                        value={subject.title}
                        onChange={handleInputChange}
                        required
                        style={{ marginTop: "10px" }}
                    />
                ) : (
                    // <Select
                    //     className="form-control"
                    //     value={subject.title || undefined}
                    //     onChange={(value) => setSubject((prev) => ({ ...prev, title: value }))}
                    //     placeholder="Sélectionnez un sujet"
                    //     style={{ width: "100%", marginTop: "10px" }}
                    // >
                    //     {titleOptions.map((title) => (
                    //         <Option key={title} value={title}>{title}</Option>
                    //     ))}
                    // </Select>
                    <Select
                        showSearch
                        className="form-control"
                        value={subject.title || undefined}
                        onChange={(value) => setSubject((prev) => ({ ...prev, title: value }))}
                        placeholder="Sélectionnez un sujet"
                        style={{ width: "100%", marginTop: "10px" }}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {titleOptions.map((title) => (
                            <Option key={title} value={title}>
                                {title}
                            </Option>
                        ))}
                    </Select>

                )}
            </div>





            {/* ✅ Sous-titre du sujet */}
            {/* <div className="mb-3">
                <label>Sous-titre du Sujet</label>
                <Checkbox
                    checked={isNewSubTitle}
                    onChange={handleNewSubTitleChange}
                    style={{ marginLeft: "10px" }}
                >
                    Nouveau sous-sujet ?
                </Checkbox>

                {isNewSubTitle ? (
                    <Input
                        type="text"
                        name="subTitle"
                        className="form-control"
                        value={subject.subTitle}
                        onChange={handleInputChange}
                        required
                        style={{ marginTop: "10px" }}
                    />
                ) : (
                    <Select
                        className="form-control"
                        value={subject.subTitle || undefined}
                        onChange={(value) => setSubject((prev) => ({ ...prev, subTitle: value }))}
                        placeholder="Sélectionnez un sous-sujet"
                        style={{ width: "100%", marginTop: "10px" }}
                    >
                        {subTitleOptions.map((subTitle) => (
                            <Option key={subTitle} value={subTitle}>
                                {subTitle}
                            </Option>
                        ))}
                    </Select>
                )}
            </div> */}
            {/* ✅ Sous-titre du sujet (Input simple) */}
            <div className="mb-3">
                <label>Sous-titre du Sujet</label>
                <Input
                    type="text"
                    name="subTitle"
                    className="form-control"
                    value={subject.subTitle}
                    onChange={handleInputChange}
                />
            </div>


            {/* ✅ Contenu du sujet */}
            <div className="mb-3">
                <label>Contenu du Sujet</label>
                <Editor
                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                    value={subject.content}
                    onInit={(evt, editor) => (editorRef.current = editor)}
                    onEditorChange={handleEditorChange}
                    init={{
                        height: 500,
                        menubar: true,
                        plugins: [
                            "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
                            "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
                            "insertdatetime", "media", "table", "help", "wordcount"
                        ],
                        toolbar: `undo redo | bold italic underline strikethrough | link image media |
            alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |
            removeformat code help`,
                        content_style: "body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; }",
                    }}
                />

                {/* <Editor
                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                    value={subject.content}
                    onInit={(evt, editor) => (editorRef.current = editor)}
                    onEditorChange={handleEditorChange}
                    init={{
                        height: 500,
                        menubar: true,
                        plugins: [
                            "link", "lists", "table", "paste", "code", "help"
                        ],
                        toolbar:
                            "undo redo | bold italic underline | link | alignleft aligncenter alignright alignjustify | removeformat",
                        content_style:
                            "body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; }",
                    }}
                /> */}
            </div>

            <Button type="primary" htmlType="submit" block loading={loading} disabled={success}>
                {success ? "Succès" : "Enregistrer"}
            </Button>
        </form>
    );
};

export default AddSubjectForm;
